<template>
  <div v-if="appointmentsToShow.length" class="appointments-tab--wrapper background pa-2">
    <v-card v-for="appointment in appointmentsToShow" :key="appointment.booking_number" class="elevation-3">
      <v-card-text class="text-subtitle-1 text-center font-weight-medium">
        <p>{{ appointment.status_title === 'See you soon!' ? $t('label.seeYouSoon') : $t('label.weShallMeet') }}</p>
        <p class="text-mini font-weight-medium mb-4">{{ $t('label.bookingNo') }}: {{ appointment.booking_number }}</p>
        <app-button gradient :secondary="appointment.book_date === today" :disabled="isPastAppointment" invert inactive :label="appointment.status_button" class="font-weight-bold px-10 mb-4" />
        <p class="secondary--text text--lighten-2 text-mini mb-1 font-weight-bold">
          {{ $t('label.dateAndTime') }}
        </p>
        <p class="text-mini font-weight-medium mb-4">
          <span class="mr-5">{{ appointment.date | shortDate }}</span>
          <span class="mr-5">{{ appointment.time | shortTime }}</span>
        </p>
        <router-link
          :to="{
            name: $constants.ROUTE_NAME.APPOINTMENT_DETAIL,
            params: { type: appointmentType === 1 ? 'upcoming' : 'past', id: appointment.booking_id }
          }"
        >
          <v-chip small link>
            {{ $t('button.details') }}
            <v-icon class="transparent" x-small>mdi-chevron-right</v-icon>
          </v-chip>
        </router-link>
      </v-card-text>
    </v-card>
  </div>
  <div v-else class="blank-message text-h6 font-weight-medium grey--text text-center">{{ isPastAppointment ? $t('label.noPassAppointments') : $t('label.noUpcomingAppointments') }}</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { AppointmentType } from '@/constants/enums'
import { uiHelper } from '@/utils'

export default {
  props: ['appointmentType'],
  data() {
    return { today: uiHelper.getTodayDate() }
  },

  computed: {
    ...mapState('appointment', ['upcomingAppointments', 'pastAppointments']),
    isPastAppointment() {
      return this.appointmentType === AppointmentType.PAST
    },

    appointmentsToShow() {
      return this.isPastAppointment ? this.pastAppointments : this.upcomingAppointments
    }
  },

  mounted() {
    if (this.isPastAppointment) {
      this.fetchPastAppointments({ type: this.appointmentType })
    } else {
      this.fetchUpcomingAppointments({ type: this.appointmentType })
    }
  },

  methods: {
    ...mapActions('appointment', ['fetchUpcomingAppointments', 'fetchPastAppointments'])
  }
}
</script>
<style lang="scss" scoped>
.blank-message {
  margin: 150px;
}
a {
  text-decoration: none;
}
</style>
